import { Injectable } from "@angular/core";

export interface SubMenu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
}
export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
  children: SubMenu[];
}

const MENUITEMS = [
  {
    state: "voyage",
    type: "link",
    name: "voyageList",
    icon: "commute",
    priv: "rd_voyage",
    children: [],
  },
  {
    state: "passagerlist",
    type: "link",
    name: "passagerList",
    icon: "groups",
    priv: "rd_passager",
    children: [],
  },
  {
    state: "reservation",
    type: "link",
    name: "reservationList",
    icon: "perm_contact_calendar",
    priv: "rd_reservation",
    children: [],
  },
  {
    state: "bagage/autre",
    type: "link",
    name: "autresentre",
    icon: "all_inclusive",
    priv: "cr_recette",
    children: [],
  },
  {
    state: "free",
    type: "link",
    name: "freecode",
    icon: "shuffle",
    priv: "rd_freeticket",
    children: [],
  },
  {
    state: "passengertravel/validation",
    type: "link",
    name: "loyalty",
    icon: "library_add",
    priv: "rd_loyalty",
    children: [],
  },
  {
    state: "collis/mail",
    type: "link",
    name: "listcollis",
    icon: "view_list",
    priv: "rd_colis",
    children: [],
  },
  {
    state: "collis/export",
    type: "link",
    name: "exportCollisBus",
    icon: "file_download",
    priv: "rd_colis",
    children: [],
  },
  {
    state: "chauffeur/statistics",
    type: "link",
    name: "driverStatistics",
    icon: "analytics",
    priv: "rd_statistics",
    children: [],
  },
  {
    state: "bus/statistics",
    type: "link",
    name: "busStatistics",
    icon: "bar_chart",
    priv: "rd_statistics",
    children: [],
  },
  {
    state: "chef-report",
    type: "link",
    name: "chefGuichetReport",
    icon: "receipt_long",
    priv: "rd_session",
    children: [],
  },
  {
    state: "daily-activity-report",
    type: "link",
    name: "Fiche d'Activités Journalières",
    icon: "assignment",
    priv: "rd_session",
    children: [],
  },
  {
    state: "session/usersession",
    type: "link",
    name: "raportsessions",
    icon: "insights",
    priv: "cr_voyage",
    children: [],
  },
  {
    state: "session",
    type: "link",
    name: "raportsession",
    icon: "update",
    priv: "rd_session",
    children: [],
  },
  {
    state: "session/collection",
    type: "link",
    name: "Session Collection",
    icon: "payments",
    priv: "rd_session",
    children: [],
  },
  {
    state: "account/treasury-management",
    type: "link",
    name: "Gestion Trésorerie & Dépenses",
    icon: "account_balance_wallet",
    priv: "rd_session",
    children: [],
  },
  {
    state: "raport",
    type: "link",
    name: "raport",
    icon: "update",
    priv: "rd_session",
    children: [],
  },
  {
    state: "fiscalite",
    type: "link",
    name: "fiscalite",
    icon: "warning",
    priv: "rd_fiscalite",
    children: [],
  },
  {
    state: "fiscalite/month-preview",
    type: "link",
    name: "monthPreview",
    icon: "calendar_month",
    priv: "rd_fiscalite",
    children: [],
  },
  {
    state: "collis/claims",
    type: "link",
    name: "Claims Follow-up",
    icon: "gavel",
    priv: "rd_colis",
    children: [],
  },
  {
    state: "daily-activity-report",
    type: "link",
    name: "Daily Activity Report",
    icon: "summarize",
    priv: "rd_session",
    children: [],
  },
];

@Injectable()
export class MenuItemsChef {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}